import axios from 'axios';
const CONTROLLER_PATH = 'Identity';
class IdentityService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? '/' + id : ''), {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getlist() {
        return axios.get(CONTROLLER_PATH + '/getlist').then((response) => ({
            data: response.data,
        }));
    }

    getTypes() {
        return axios.get(CONTROLLER_PATH + '/getTypes').then((response) => ({
            data: response.data,
        }));
    }

    getByIdentificationTypeAndNumber(urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + '/getByIdentificationTypeAndNumber', {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    verifyRsaId(idNumber) {
        return axios.get(CONTROLLER_PATH + '/verifyRsaId/' + idNumber).then((response) => ({
            data: response.data,
        }));
    }
    
    //UPDATE
    update(id, formData) {
        return axios
            .put(CONTROLLER_PATH + '/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    /*
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
    */
}

export default new IdentityService();
